import React, { useContext, useState } from 'react';
import { Context } from '../../../Context';
import {IProps, IState} from './types';
import * as S from './styles';
import { sameElementType } from '@utils/editor'
import { ArrowLeftIcon } from '@assets/icons/arrowLeftIcon';
import Button from '@components/Button';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import actions from '@state/actions';
import { useDispatch } from 'react-redux';

const VersionCommandBar:React.FC<IProps> = (props) => {
  const [restoring, setRestoring] = useState(false);
  const context = useContext(Context);
  const authContext = useContext(AuthContext);

  const dispatch = useDispatch();

  const handleBack=()=>{
    if (!restoring)
      context.onSelectEditMode(true);   
  }
  
  const getVersionText=()=>{
    return (
      <>
        {context.editorStatus.selectedVersion && new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit', hour:'2-digit', minute:'2-digit'}).format(new Date(context.editorStatus.selectedVersion.createdDate))} by {context.editorStatus.selectedVersion!.createdBy.name}
      </>
    )
  }

  async function restoreChange(id:string){                  
    const data: any = await  restoreParsedTreeChange(id);     
    //if (data)
    context.onRestoreVersion();
  }

  const restoreParsedTreeChange = (id:string) => {    
    setRestoring(true);    
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };

    return new Promise((resolve, reject) => {                  
      dispatch(actions.parsedTrees.restoreParsedTreeChange(id, context.parsedTreeInfo.id, userData, (result, error) => {                    
        if (error) reject(error)
        else {            
          setRestoring(false);        
          resolve(result)}
      }))
    });
  }

  const handleRestore=()=> {
    if (!restoring)
    {
      if (context.editorStatus && context.editorStatus.selectedVersion)
        restoreChange(context.editorStatus.selectedVersion?.id);
    }
  }

  return (
    <S.Root>   
      <S.BackContainer onClick={() => handleBack()}>
          <ArrowLeftIcon style={{marginRight: '5.5px'}}/>           
      </S.BackContainer>
      {
        context.editorStatus.selectedVersion &&
        <>
      <Button 
              label={
                restoring ? "RESTORING..." : "RESTORE VERSION" 
              }
              style={{hoverBackgroundColor: "#344a70", 
                      backgroundColor: "#366cc8", 
                      margin:'7px',                      
                      width: '140px',              
                      height: '10px'        
                    }} 
              onClick={handleRestore}
              disabled={false}
          />
          <S.Label>
          { getVersionText()  }
          </S.Label>
          </>
      }
    </S.Root>
  );
}

export default VersionCommandBar;